import client1 from "../assets/clients/client1.png";
import client2 from "../assets/clients/client2.png";
import client3 from "../assets/clients/client3.png";
import client4 from "../assets/clients/client4.png";
import client5 from "../assets/clients/client5.png";
import client6 from "../assets/clients/client6.png";
import client7 from "../assets/clients/client7.jpg";
import client8 from "../assets/clients/client8.png";
import client9 from "../assets/clients/client9.png";
import client10 from "../assets/clients/client10.png";
import client11 from "../assets/clients/client11.png";
import client12 from "../assets/clients/client12.png";
import client13 from "../assets/clients/client13.png";
import client14 from "../assets/clients/client14.png";
import client15 from "../assets/clients/client15.png";
import client16 from "../assets/clients/client16.png";
import client17 from "../assets/clients/client17.jpg";
import client18 from "../assets/clients/client18.png";
import client19 from "../assets/clients/client19.png";

export const clientsList = [
    {
        img: client1,
        alt: 'Client 1',
    },
    {
        img: client2,
        alt: 'Client 2',
    },
    {
        img: client3,
        alt: 'Client 3',
    },
    {
        img: client4,
        alt: 'Client 4',
    },
    {
        img: client5,
        alt: 'Client 5',
    },
    {
        img: client6,
        alt: 'Client 6',
    },
    {
        img: client7,
        alt: 'Client 7',
    },
    {
        img: client8,
        alt: 'Client 8',
    },
    {
        img: client9,
        alt: 'Client 9',
    },
    {
        img: client10,
        alt: 'Client 10',
    },
    {
        img: client11,
        alt: 'Client 11',
    },
    {
        img: client12,
        alt: 'Client 12',
    },
    {
        img: client13,
        alt: 'Client 13',
    },
    {
        img: client14,
        alt: 'Client 14',
    },
    {
        img: client15,
        alt: 'Client 15',
    },
    {
        img: client16,
        alt: 'Client 16',
    },
    {
        img: client17,
        alt: 'Client 17',
    },
    {
        img: client18,
        alt: 'Client 18',
    },
    {
        img: client19,
        alt: 'Client 19',
    }
];
